/**
 * jornadaTurnos.ts — Slots fijos de turno para agrupar cierres del mismo día.
 */

export type JornadaTurnoKey = "manana" | "tarde" | "noche";

export interface JornadaTurnoSlot {
  key: JornadaTurnoKey;
  label: string;
  emoji: string;
  /** Hora local de apertura típica (inclusive). */
  hourStart: number;
  /** Hora local de cierre típico (exclusive). */
  hourEnd: number;
}

export const JORNADA_TURNOS: readonly JornadaTurnoSlot[] = [
  {
    key: "manana",
    label: "Turno Mañana",
    emoji: "🌅",
    hourStart: 5,
    hourEnd: 12,
  },
  {
    key: "tarde",
    label: "Turno Tarde",
    emoji: "🌇",
    hourStart: 12,
    hourEnd: 18,
  },
  {
    key: "noche",
    label: "Turno Noche",
    emoji: "🌃",
    hourStart: 18,
    hourEnd: 24,
  },
] as const;

const LABEL_HINTS: Record<JornadaTurnoKey, string[]> = {
  manana: ["mañana", "manana", "morning"],
  tarde: ["tarde", "afternoon"],
  noche: ["noche", "night"],
};

/** Día calendario local `YYYY-MM-DD` desde un ISO de apertura/cierre. */
export function calendarDayFromIso(iso: string): string {
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function matchCierreToJornadaTurno(cierre: {
  abiertaEn: string;
  label?: string;
}): JornadaTurnoKey | null {
  const label = (cierre.label ?? "").toLowerCase();
  for (const slot of JORNADA_TURNOS) {
    if (LABEL_HINTS[slot.key].some((h) => label.includes(h))) return slot.key;
  }
  const hour = new Date(cierre.abiertaEn).getHours();
  const byHour = JORNADA_TURNOS.find(
    (s) => hour >= s.hourStart && hour < s.hourEnd,
  );
  return byHour?.key ?? null;
}

export function turnoSlotByKey(key: JornadaTurnoKey): JornadaTurnoSlot {
  return JORNADA_TURNOS.find((s) => s.key === key) ?? JORNADA_TURNOS[0];
}
